<div class="gen-cart-item" [class.is-delivery-group]="isCheckoutPage">
  <div class="gen-cart-item-image-block">
    <cx-media class="cx-product-image"
      *ngIf="(item.product.servicePart && item.product.images) || !item.product.servicePart; else spGearThumb"
      [container]="imageContainer" format="product" [alt]="item.product.name || item.product.summary"></cx-media>
    <ng-template #spGearThumb>
      <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
    </ng-template>
  </div>

  <div class="gen-cart-item-block">
    <div class="gen-cart-item-block-item">
      <div *ngIf="item.product?.code && !item.product?.displayModelNumber" class="gen-cart-item-block-item-model">
        {{ (item.product?.servicePart ? 'cartItems.part' : 'cartItems.id') | cxTranslate }} #{{ item.product?.code }}
      </div>
      <div *ngIf="item.product?.displayModelNumber" class="gen-cart-item-block-item-model">
        {{ (item.product?.servicePart ? 'cartItems.part' : 'cartItems.id') | cxTranslate }} #{{
        item.product?.displayModelNumber }}
      </div>
      <div class="gen-cart-item-block-item-name">{{item.product?.name}}</div>
      <div class="cx-code cx-delivery">
        <div *ngIf="item.availabilityMessage" class="availability-message-block">
          <img src="../../../../../../assets/icons/delivery_icon_black_24.svg" />
          <span class="availability-msg">{{ item.availabilityMessage }}</span>
        </div>
        <div class="sp-product-icons" *ngIf="isServicePartsEnabled && item.product?.servicePart">
          <gen-sp-icons [product]="item.product" [changeTooltipPosition]="true"
            [showGreenCheck]="item.itemOnHand"></gen-sp-icons>
        </div>
      </div>
      <button *ngIf="sppFormValue && (isReviewOrder || isOrderConfirmation)" class="btn add-consumer-details-btn"
        [class.add-consumer-details-btn-expanded]="isConsumerDetailsSectionExpanded"
        (click)="expandConsumerDetailsSection()" (genSizeChanged)="onResize()">
        {{ (isBuilderSpp() ? 'cartItems.builderDetails' : 'cartItems.consumerDetails') | cxTranslate }}
        <img src="../../../../../../assets/icons/expand_more_black_24.svg" />
      </button>
      <gen-spp-consumer-details-form *ngIf="isConsumerDetailsSectionExpanded && (isReviewOrder || isOrderConfirmation)"
        #consumerDetailsSection [sppFormValue]="sppFormValue" [quantity]="item.quantity"
        [entryNumber]="item.entryNumber" [readonly]="isReviewOrder || isOrderConfirmation" [showEditBtn]="isReviewOrder"
        (genSizeChanged)="onResize()"></gen-spp-consumer-details-form>
    </div>
    <div class="gen-cart-item-block-price" *ngIf="!isCheckoutPage">
      <div class="gen-cart-item-block-price-title">{{ 'cartItems.itemPrice' | cxTranslate }}</div>
      <div class="gen-cart-item-block-price-value">{{ item.basePrice?.formattedValue }}</div>
    </div>
    <div *ngIf="quantityControl || (isCheckoutPage && isServicePartsEnabled)" [class.readonly-value]="readonly"
      [class.gen-cart-item-block-qty]="isCheckoutPage">
      <ng-container *ngIf="isCheckoutPage">
        <div class="gen-cart-item-block-qty-title">{{ 'savedCartList.quantity' | cxTranslate }}</div>
        <div class="gen-cart-item-block-qty-value">{{ quantityControl?.value || item?.quantity }}</div>
      </ng-container>
      <gen-item-counter *ngIf="!isCheckoutPage" [control]="quantityControl" [item]="item"
        [navigatedToPpdFrom]="navigatedToPpdFrom" [gaListName]="gaListName" [gaEntrySource]="gaEntrySource"
        [readonly]="!item.updateable || !!readonly || !!options.isSaveForLater" [min]="+item.product?.minOrderQuantity"
        [step]="+item.product?.addToCartQtyMultiplier" [max]="+item.product?.maxOrderQuantity"
        messagePosition="position-right" [allowZero]="true"></gen-item-counter>
    </div>

    <div class="gen-cart-item-block-total">
      <div class="gen-cart-item-block-total-title">
        {{ 'cartItems.total' | cxTranslate }}
      </div>
      <div *ngIf="item.basePrice?.value && item.totalPrice?.currencyIso" class="gen-cart-item-block-total-value">
        {{ (item.basePrice?.value * item.quantity) | currency: item.totalPrice.currencyIso }}
      </div>
    </div>
    <div class="gen-cart-item-block-actions" *ngIf="!readonly">
      <button (click)="handleRemoveItem(item)" [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
        [disabled]="quantityControl.disabled" [attr.aria-label]="'addToCart.removeFromCart' | cxTranslate"
        class="link cx-action-link">
        <cx-icon [type]="iconTypes.TRASH"></cx-icon>
      </button>
    </div>
  </div>
</div>